'use client';

import {motion} from 'framer-motion';
import {useState} from 'react';
import {useViewport, withinOrWiderThan} from '@udemy-v2/react-layout-components';

import {AccordionTab} from './accordion-tab';
import {AccordionTabMobile} from './accordion-tab-mobile';
import styles from './accordion.module.scss';

interface AccordionProps {
    tabs: {
        title: string;
        content: React.ReactNode;
    }[];
}

export function Accordion({tabs}: AccordionProps) {
    const [expanded, setExpanded] = useState<false | number>(0);
    const {range} = useViewport();
    const isWideViewport = range && withinOrWiderThan(range, 'xl');
    const AccordionTabComponent = isWideViewport ? AccordionTab : AccordionTabMobile;

    return (
        <motion.div
            className={styles.accordion}
            initial={{opacity: 0}}
            animate={{opacity: 1}}
            transition={{duration: 0.5}}
        >
            {tabs.map((tab, index) => (
                <AccordionTabComponent
                    key={index}
                    title={tab.title}
                    expanded={expanded === index}
                    onClick={() => setExpanded(index)}
                >
                    {tab.content}
                </AccordionTabComponent>
            ))}
        </motion.div>
    );
}
